<template>
  <section class="framer-1qck8cj" data-framer-name="Feature highlights section" id="more-features"
    name="Feature highlights section">
    <div class="framer-4be64n" data-framer-name="Feature highlights" name="Feature highlights">
      <header class="framer-8ulj16" data-framer-name="Title" name="Title">
        <div class="framer-1qzp1fz"
          style="outline:none;display:flex;flex-direction:column;justify-content:flex-start;flex-shrink:0;transform:none"
          data-framer-component-type="RichTextContainer">
          <h2 class="framer-text framer-styles-preset-gx26df" data-styles-preset="k3Ea6rV_p"
            style="--framer-text-color:var(--token-fe65a76b-2bec-47ef-8ad1-5fc7a52718d1, #45196e)">
            Eligibility Criteria</h2>
        </div>
        <div class="framer-183gqlv"
          style="outline:none;display:flex;flex-direction:column;justify-content:flex-start;flex-shrink:0;transform:none"
          data-framer-component-type="RichTextContainer">
          <p class="framer-text framer-styles-preset-1ti5524" data-styles-preset="u7aiLhMMc"
            style="--framer-text-color:var(--token-72e8df52-57a2-46b1-82a3-f1511a4cdd86, rgb(16, 16, 16))">This
            programme is designed to accelerate the adoption of advanced technologies among manufacturing
            companies, enabling them to transform into highly efficient and digitally connected smart factories.</p>
        </div>
      </header>
      <div class="framer-1helebq" data-framer-name="Feature cards" name="Feature cards" ref="eligibilityGroup">
        <div class="ssr-variant hidden-15sd5ma">
          <!-- <div class="framer-146ug7d-container" style="opacity: 0; transform: translateY(150px);"> -->
          <div class="framer-146ug7d-container" id="146ug7d" ref="card1">
            <div class="framer-jrrtp framer-mp0BS framer-1pgffi3 framer-v-2rayaf" data-framer-name="Invert"
              data-highlight="true"
              style="background-color: var(--token-fe65a76b-2bec-47ef-8ad1-5fc7a52718d1, #45196e); border-radius: 8px; width: 100%; opacity: 1;"
              tabindex="0">
              <div class="framer-5xvaod" data-framer-name="Title" style="opacity: 1;">
                <div class="framer-l5gh6j-container" style="opacity: 1;">
                  <div class="framer-vp0Ob framer-1u2bk8 framer-v-127hjcv" data-framer-name="Variant 3"
                    style="background-color: var(--token-a8d4d279-80d0-45a4-9f3d-79620f9c0f86, rgb(253, 184, 18)); border-radius: 99px; height: 100%; width: 100%; opacity: 1;">
                    <div class="framer-zbdg4"
                      style="outline: none; display: flex; flex-direction: column; justify-content: flex-start; flex-shrink: 0; --extracted-r6o4lv: var(--token-fe65a76b-2bec-47ef-8ad1-5fc7a52718d1, #45196e); --framer-link-text-color: rgb(0, 153, 255); --framer-link-text-decoration: underline; transform: none; opacity: 1;"
                      data-framer-component-type="RichTextContainer">
                      <p style="--framer-text-alignment:center;--framer-text-color:var(--extracted-r6o4lv, var(--token-fe65a76b-2bec-47ef-8ad1-5fc7a52718d1, #45196e))"
                        class="framer-text">1</p>
                    </div>
                  </div>
                </div>
                <div class="framer-8llph" style="opacity: 1;">
                  <div class="framer-1l9e0cm"
                    style="outline: none; display: flex; flex-direction: column; justify-content: flex-start; flex-shrink: 0; --framer-link-text-color: rgb(0, 153, 255); --framer-link-text-decoration: underline; --extracted-1w1cjl5: var(--token-a0c2593c-6916-4188-ac50-f5131b23cc3f, rgb(255, 255, 255)); transform: none; opacity: 1;"
                    data-framer-component-type="RichTextContainer">
                    <h6 class="framer-text framer-styles-preset-w98w3a" data-styles-preset="HNXRxYFmQ"
                      style="--framer-text-color:var(--extracted-1w1cjl5, var(--token-a0c2593c-6916-4188-ac50-f5131b23cc3f, rgb(255, 255, 255)))">
                      Incorporated under the Companies Act, 2016</h6>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="ssr-variant hidden-15sd5ma">
          <!-- <div class="framer-19vsxtc-container" style="opacity: 0; transform: translateY(150px);"> -->
          <div class="framer-19vsxtc-container" id="19vsxtc" ref="card2" style="animation-delay: 0.0s;">
            <div class="framer-jrrtp framer-mp0BS framer-1pgffi3 framer-v-2rayaf" data-framer-name="Invert"
              data-highlight="true"
              style="background-color: var(--token-fe65a76b-2bec-47ef-8ad1-5fc7a52718d1, #45196e); border-radius: 8px; width: 100%; opacity: 1;"
              tabindex="0">
              <div class="framer-5xvaod" data-framer-name="Title" style="opacity: 1;">
                <div class="framer-l5gh6j-container" style="opacity: 1;">
                  <div class="framer-vp0Ob framer-1u2bk8 framer-v-127hjcv" data-framer-name="Variant 3"
                    style="background-color: var(--token-a8d4d279-80d0-45a4-9f3d-79620f9c0f86, rgb(253, 184, 18)); border-radius: 99px; height: 100%; width: 100%; opacity: 1;">
                    <div class="framer-zbdg4"
                      style="outline: none; display: flex; flex-direction: column; justify-content: flex-start; flex-shrink: 0; --extracted-r6o4lv: var(--token-fe65a76b-2bec-47ef-8ad1-5fc7a52718d1, #45196e); --framer-link-text-color: rgb(0, 153, 255); --framer-link-text-decoration: underline; transform: none; opacity: 1;"
                      data-framer-component-type="RichTextContainer">
                      <p style="--framer-text-alignment:center;--framer-text-color:var(--extracted-r6o4lv, var(--token-fe65a76b-2bec-47ef-8ad1-5fc7a52718d1, #45196e))"
                        class="framer-text">2</p>
                    </div>
                  </div>
                </div>
                <div class="framer-8llph" style="opacity: 1;">
                  <div class="framer-1l9e0cm"
                    style="outline: none; display: flex; flex-direction: column; justify-content: flex-start; flex-shrink: 0; --framer-link-text-color: rgb(0, 153, 255); --framer-link-text-decoration: underline; --extracted-1w1cjl5: var(--token-a0c2593c-6916-4188-ac50-f5131b23cc3f, rgb(255, 255, 255)); transform: none; opacity: 1;"
                    data-framer-component-type="RichTextContainer">
                    <h6 class="framer-text framer-styles-preset-w98w3a" data-styles-preset="HNXRxYFmQ"
                      style="--framer-text-color:var(--extracted-1w1cjl5, var(--token-a0c2593c-6916-4188-ac50-f5131b23cc3f, rgb(255, 255, 255)))">
                      At least 51% Malaysian owned</h6>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="ssr-variant hidden-15sd5ma">
          <!-- <div class="framer-dbbeun-container" style="opacity: 0; transform: translateY(150px);"> -->
          <div class="framer-dbbeun-container" id="dbbeun"ref="card3" style="animation-delay: 0.0s;">
            <div class="framer-jrrtp framer-mp0BS framer-1pgffi3 framer-v-2rayaf" data-framer-name="Invert"
              data-highlight="true"
              style="background-color: var(--token-fe65a76b-2bec-47ef-8ad1-5fc7a52718d1, #45196e); border-radius: 8px; width: 100%; opacity: 1;"
              tabindex="0">
              <div class="framer-5xvaod" data-framer-name="Title" style="opacity: 1;">
                <div class="framer-l5gh6j-container" style="opacity: 1;">
                  <div class="framer-vp0Ob framer-1u2bk8 framer-v-127hjcv" data-framer-name="Variant 3"
                    style="background-color: var(--token-a8d4d279-80d0-45a4-9f3d-79620f9c0f86, rgb(253, 184, 18)); border-radius: 99px; height: 100%; width: 100%; opacity: 1;">
                    <div class="framer-zbdg4"
                      style="outline: none; display: flex; flex-direction: column; justify-content: flex-start; flex-shrink: 0; --extracted-r6o4lv: var(--token-fe65a76b-2bec-47ef-8ad1-5fc7a52718d1, #45196e); --framer-link-text-color: rgb(0, 153, 255); --framer-link-text-decoration: underline; transform: none; opacity: 1;"
                      data-framer-component-type="RichTextContainer">
                      <p style="--framer-text-alignment:center;--framer-text-color:var(--extracted-r6o4lv, var(--token-fe65a76b-2bec-47ef-8ad1-5fc7a52718d1, #45196e))"
                        class="framer-text">3</p>
                    </div>
                  </div>
                </div>
                <div class="framer-8llph" style="opacity: 1;">
                  <div class="framer-1l9e0cm"
                    style="outline: none; display: flex; flex-direction: column; justify-content: flex-start; flex-shrink: 0; --framer-link-text-color: rgb(0, 153, 255); --framer-link-text-decoration: underline; --extracted-1w1cjl5: var(--token-a0c2593c-6916-4188-ac50-f5131b23cc3f, rgb(255, 255, 255)); transform: none; opacity: 1;"
                    data-framer-component-type="RichTextContainer">
                      <h6 class="framer-text framer-styles-preset-w98w3a" data-styles-preset="HNXRxYFmQ"
                        style="--framer-text-color:var(--extracted-1w1cjl5, var(--token-a0c2593c-6916-4188-ac50-f5131b23cc3f, rgb(255, 255, 255)))">
                        <a @click="openGuideline" target="_blank" rel="noopener">
                          <h6 class="framer-text framer-styles-preset-w98w3a hoverunderline" data-styles-preset="HNXRxYFmQ"
                          style="--framer-text-color:var(--extracted-1w1cjl5, var(--token-a0c2593c-6916-4188-ac50-f5131b23cc3f, rgb(255, 255, 255))); display: inline-block;">
                          SMEs</h6>
                        </a> and 
                        <el-tooltip placement="top-start" effect="lightfull">
                          <div slot="content">
                            <div class="framer-xa3s97 framer-bLVSP">
                              <p class="framer-text framer-styles-preset-11do9gc" data-styles-preset="AW4fNdX5r">
                                <br class="framer-text">Malaysian Mid-Tier Companies are companies with annual revenue of RM50million to RM500million (Manufacturing) OR RM20million to RM500million (Non-manufacturing & services)
                              </p>
                            </div>
                          </div>
                          <span class="textHover">
                            Mid-Tier
                          </span>
                      </el-tooltip>
                      </h6>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="ssr-variant hidden-15sd5ma">
          <!-- <div class="framer-1lzx02o-container" style="opacity: 0; transform: translateY(150px);"> -->
          <div class="framer-1lzx02o-container" id="1lzx02o" ref="card4" style="animation-delay: 0.0s;">
            <div class="framer-jrrtp framer-mp0BS framer-1pgffi3 framer-v-2rayaf" data-framer-name="Invert"
              data-highlight="true"
              style="background-color: var(--token-fe65a76b-2bec-47ef-8ad1-5fc7a52718d1, #45196e); border-radius: 8px; width: 100%; opacity: 1;"
              tabindex="0">
              <div class="framer-5xvaod" data-framer-name="Title" style="opacity: 1;">
                <div class="framer-l5gh6j-container" style="opacity: 1;">
                  <div class="framer-vp0Ob framer-1u2bk8 framer-v-127hjcv" data-framer-name="Variant 3"
                    style="background-color: var(--token-a8d4d279-80d0-45a4-9f3d-79620f9c0f86, rgb(253, 184, 18)); border-radius: 99px; height: 100%; width: 100%; opacity: 1;">
                    <div class="framer-zbdg4"
                      style="outline: none; display: flex; flex-direction: column; justify-content: flex-start; flex-shrink: 0; --extracted-r6o4lv: var(--token-fe65a76b-2bec-47ef-8ad1-5fc7a52718d1, #45196e); --framer-link-text-color: rgb(0, 153, 255); --framer-link-text-decoration: underline; transform: none; opacity: 1;"
                      data-framer-component-type="RichTextContainer">
                      <p style="--framer-text-alignment:center;--framer-text-color:var(--extracted-r6o4lv, var(--token-fe65a76b-2bec-47ef-8ad1-5fc7a52718d1, #45196e))"
                        class="framer-text">4</p>
                    </div>
                  </div>
                </div>
                <div class="framer-8llph" style="opacity: 1;">
                  <div class="framer-1l9e0cm"
                    style="outline: none; display: flex; flex-direction: column; justify-content: flex-start; flex-shrink: 0; --framer-link-text-color: rgb(0, 153, 255); --framer-link-text-decoration: underline; --extracted-1w1cjl5: var(--token-a0c2593c-6916-4188-ac50-f5131b23cc3f, rgb(255, 255, 255)); transform: none; opacity: 1;"
                    data-framer-component-type="RichTextContainer">
                    <h6 class="framer-text framer-styles-preset-w98w3a" data-styles-preset="HNXRxYFmQ"
                      style="--framer-text-color:var(--extracted-1w1cjl5, var(--token-a0c2593c-6916-4188-ac50-f5131b23cc3f, rgb(255, 255, 255)))">
                      At least 3 years in operation</h6>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="ssr-variant hidden-15sd5ma">
          <!-- <div class="framer-az0ms2-container" style="opacity: 0; transform: translateY(150px);"> -->
          <div class="framer-az0ms2-container" id="az0ms2" ref="card5" style="animation-delay: 0.0s;">
            <div class="framer-jrrtp framer-mp0BS framer-1pgffi3 framer-v-2rayaf" data-framer-name="Invert"
              data-highlight="true"
              style="background-color: var(--token-fe65a76b-2bec-47ef-8ad1-5fc7a52718d1, #45196e); border-radius: 8px; width: 100%; opacity: 1;"
              tabindex="0">
              <div class="framer-5xvaod" data-framer-name="Title" style="opacity: 1;">
                <div class="framer-l5gh6j-container" style="opacity: 1;">
                  <div class="framer-vp0Ob framer-1u2bk8 framer-v-127hjcv" data-framer-name="Variant 3"
                    style="background-color: var(--token-a8d4d279-80d0-45a4-9f3d-79620f9c0f86, rgb(253, 184, 18)); border-radius: 99px; height: 100%; width: 100%; opacity: 1;">
                    <div class="framer-zbdg4"
                      style="outline: none; display: flex; flex-direction: column; justify-content: flex-start; flex-shrink: 0; --extracted-r6o4lv: var(--token-fe65a76b-2bec-47ef-8ad1-5fc7a52718d1, #45196e); --framer-link-text-color: rgb(0, 153, 255); --framer-link-text-decoration: underline; transform: none; opacity: 1;"
                      data-framer-component-type="RichTextContainer">
                      <p style="--framer-text-alignment:center;--framer-text-color:var(--extracted-r6o4lv, var(--token-fe65a76b-2bec-47ef-8ad1-5fc7a52718d1, #45196e))"
                        class="framer-text">5</p>
                    </div>
                  </div>
                </div>
                <div class="framer-8llph" style="opacity: 1;">
                  <div class="framer-1l9e0cm"
                    style="outline: none; display: flex; flex-direction: column; justify-content: flex-start; flex-shrink: 0; --framer-link-text-color: rgb(0, 153, 255); --framer-link-text-decoration: underline; --extracted-1w1cjl5: var(--token-a0c2593c-6916-4188-ac50-f5131b23cc3f, rgb(255, 255, 255)); transform: none; opacity: 1;"
                    data-framer-component-type="RichTextContainer">
                    <h6 class="framer-text framer-styles-preset-w98w3a" data-styles-preset="HNXRxYFmQ"
                      style="--framer-text-color:var(--extracted-1w1cjl5, var(--token-a0c2593c-6916-4188-ac50-f5131b23cc3f, rgb(255, 255, 255)))">
                      Valid business license from local authority</h6>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="ssr-variant hidden-15sd5ma">
          <!-- <div class="framer-qp0sb9-container" id="qp0sb9" style="opacity: 0; transform: translateY(150px);"> -->
          <div class="framer-qp0sb9-container" id="qp0sb9" ref="card6" style="animation-delay: 0.0;">
            <el-tooltip placement="top-start" effect="lightfull">
              <div slot="content">
                <div class="framer-xa3s97 framer-bLVSP">
                  <p class="framer-text framer-styles-preset-11do9gc" data-styles-preset="AW4fNdX5r">
                    <strong class="framer-text">Manufacturing</strong>
                    <strong class="framer-text"><br
                        class="framer-text"></strong>Manufacturers engage with manufacturing activities with valid Manufacturing
                    License (ML) or Letter of Exemption of ML from MIDA in compliance with the Industrial Coordination Act, 1975.<br
                      class="framer-text"><br class="framer-text"><strong class="framer-text">Manufacturing Related Services
                      (MRS)</strong><br class="framer-text">An MRS company is defined as organisations that provide services from
                    pre-manufacturing to after sales which significantly contribute to creating value-add to manufacturing sectors
                  </p>
                </div>
              </div>
              <div class="framer-jrrtp framer-mp0BS framer-1pgffi3 framer-v-2rayaf" data-framer-name="Invert"
                data-highlight="true"
                style="background-color: var(--token-fe65a76b-2bec-47ef-8ad1-5fc7a52718d1, #45196e); border-radius: 8px; width: 100%; opacity: 1;"
                tabindex="0">
                <div class="framer-5xvaod" data-framer-name="Title" style="opacity: 1;">
                  <div class="framer-l5gh6j-container" style="opacity: 1;">
                    <div class="framer-vp0Ob framer-1u2bk8 framer-v-127hjcv" data-framer-name="Variant 3"
                      style="background-color: var(--token-a8d4d279-80d0-45a4-9f3d-79620f9c0f86, rgb(253, 184, 18)); border-radius: 99px; height: 100%; width: 100%; opacity: 1;">
                      <div class="framer-zbdg4"
                        style="outline: none; display: flex; flex-direction: column; justify-content: flex-start; flex-shrink: 0; --extracted-r6o4lv: var(--token-fe65a76b-2bec-47ef-8ad1-5fc7a52718d1, #45196e); --framer-link-text-color: rgb(0, 153, 255); --framer-link-text-decoration: underline; transform: none; opacity: 1;"
                        data-framer-component-type="RichTextContainer">
                        <p style="--framer-text-alignment:center;--framer-text-color:var(--extracted-r6o4lv, var(--token-fe65a76b-2bec-47ef-8ad1-5fc7a52718d1, #45196e))"
                          class="framer-text">6</p>
                      </div>
                    </div>
                  </div>
                  <div class="framer-8llph" style="opacity: 1;">
                    <div class="framer-1l9e0cm"
                      style="outline: none; display: flex; flex-direction: column; justify-content: flex-start; flex-shrink: 0; --framer-link-text-color: rgb(0, 153, 255); --framer-link-text-decoration: underline; --extracted-1w1cjl5: var(--token-a0c2593c-6916-4188-ac50-f5131b23cc3f, rgb(255, 255, 255)); transform: none; opacity: 1;"
                      data-framer-component-type="RichTextContainer">
                      <h6 class="framer-text framer-styles-preset-w98w3a" data-styles-preset="HNXRxYFmQ"
                        style="--framer-text-color:var(--extracted-1w1cjl5, var(--token-a0c2593c-6916-4188-ac50-f5131b23cc3f, rgb(255, 255, 255)))">
                        Manufacturing OR Manufacturing Related Services (MRS)</h6>
                    </div>
                    <div class="framer-17sg3r6-container" style="opacity: 1;">
                      <div style="display:contents"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
                          fill="currentColor" aria-hidden="true" data-slot="icon"
                          color="var(--token-a0c2593c-6916-4188-ac50-f5131b23cc3f, rgb(255, 255, 255))"
                          style="width: 100%; height: 100%;">
                          <path fill-rule="evenodd"
                            d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm8.706-1.442c1.146-.573 2.437.463 2.126 1.706l-.709 2.836.042-.02a.75.75 0 0 1 .67 1.34l-.04.022c-1.147.573-2.438-.463-2.127-1.706l.71-2.836-.042.02a.75.75 0 1 1-.671-1.34l.041-.022ZM12 9a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z"
                            clip-rule="evenodd"></path>
                        </svg></div>
                    </div>
                  </div>
                </div>
              </div>
            </el-tooltip>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import guideline2024 from '@/assets/guideline2024.pdf';

export default {
  name: 'part-2-landing-page',
  inheritAttrs: false,
  data() {
    return {
      triggeredFadeIn1: false,
      triggeredFadeIn2: false,
      triggeredFadeIn3: false,
      triggeredFadeIn4: false,
      triggeredFadeIn5: false,
      triggeredFadeIn6: false,
      completedAll: false
    }
  },
  methods: {
    openGuideline() {
      window.open(guideline2024, '_blank', 'noopener');
    }
  },
  props: {
    currentScroll: {
      type: Number,
      default: 0
    }
  },
  watch: {
    currentScroll() {
      console.log('currentScroll', this.currentScroll)
      if (!this.completedAll) {
        const eligibilityGroupStart = 288
        const step = 100
        const card1Start = eligibilityGroupStart
        const card2Start = eligibilityGroupStart + step * 1
        const card3Start = eligibilityGroupStart + step * 1.5
        const card4Start = eligibilityGroupStart + step * 2.5
        const card5Start = eligibilityGroupStart + step * 3
        const card6Start = eligibilityGroupStart + step * 3.5
        if (this.$refs.card1 && this.currentScroll >= card1Start && !this.triggeredFadeIn1) {
          this.$refs.card1.classList.add('featureCardAnimation')
          this.triggeredFadeIn1 = true
        }
        if (this.$refs.card2 && this.currentScroll >= card2Start && !this.triggeredFadeIn2) {
          this.$refs.card2.classList.add('featureCardAnimation')
          this.triggeredFadeIn2 = true
        }
        if (this.$refs.card3 && this.currentScroll >= card3Start && !this.triggeredFadeIn3) {
          this.$refs.card3.classList.add('featureCardAnimation')
          this.triggeredFadeIn3 = true
        }
        if (this.$refs.card4 && this.currentScroll >= card4Start && !this.triggeredFadeIn4) {
          this.$refs.card4.classList.add('featureCardAnimation')
          this.triggeredFadeIn4 = true
        }
        if (this.$refs.card5 && this.currentScroll >= card5Start && !this.triggeredFadeIn5) {
          this.$refs.card5.classList.add('featureCardAnimation')
          this.triggeredFadeIn5 = true
        }
        if (this.$refs.card6 && this.currentScroll >= card6Start && !this.triggeredFadeIn6) {
          this.$refs.card6.classList.add('featureCardAnimation')
          this.triggeredFadeIn6 = true
        }
        if (this.triggeredFadeIn1 && this.triggeredFadeIn2 && this.triggeredFadeIn3 && this.triggeredFadeIn4 && this.triggeredFadeIn5 && this.triggeredFadeIn6) {
          this.completedAll = true
        }
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/views/msma/components/Part2LandingPage/index.vue